import {createMuiTheme}         from '@material-ui/core/styles';
import {colores}                from './global';

//const movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const theme = createMuiTheme({
    palette: {
        //type: 'dark',
        secondary: { main: colores.naranja },
        primary: { main: colores.azul },
      },
      typography: {
        body1: {
          fontSize: 12,
        },
        body2: {
          fontSize: "12px !important",
        },
        subtitle1: { fontSize: 14 },
        subtitle2: { fontSize: 15 },
        h5: { fontSize: 16 },
        h6: { fontSize: 14 },
      },
      overrides: {
        MuiInputLabel: {
          root: {
            "&$shrink": {
              fontSize: 16,
              background: "#ffffff",
              padding: "0px 4px 0px 0px",
            },
          },
        },
        MuiInputBase: {
          root: {
            fontSize: "12px !important",
          },
        },
        MuiTooltip: {
          tooltip: {
            fontSize: 12,
          },
        },
        MuiTableRow: {
          root: {
            "&:first-child th": {
              color: "white",
            },
          },
        },
        MuiTabs: {
          root: {
            color: "white",
            backgroundColor: colores.azul,
          },
          indicator: {
            backgroundColor: colores.naranja,
          },
        },
        MuiDialogTitle: {
          root: {
            textAlign: "center",
            color: "white",
            backgroundColor: colores.azul,
            paddingTop: "8px",
            paddingBottom: "8px",
          },
        },
        MuiDialogContent: {
          root: {
            paddingLeft: "10px",
            paddingRight: "10px",
            marginLeft: "8px",
            marginRight: "8px",
            paddingBottom: "0px",
            paddingTop: "18px",
          },
        },
        MuiDialogActions: {
          root: {
            justifyContent: "center",
            marginLeft: "0px",
            marginRight: "0px",
          },
        },
        MuiTableCell: {
          root: {
            paddingTop: "12px",
            paddingBottom: "12px",
          },
          body: {
            height: "43px",
          },
          footer: {
            height: "43px",
          },
        },
        MuiInput: {
          input: {
            fontSize: "12px !important",
          },
        },
        MuiListSubheader: {
          root: {
            fontSize: 12,
            paddingTop: "10px !important",
            maxHeight: "45px !important",
            minHeight: "45px !important",
            color: colores.azul,
            backgroundColor: "#FFFFFF !important",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            display: "flex",
            alignItems: "bottom",
          },
        },
      },
      props: {
        MuiButtonBase: {
          disableRipple: true,
        },
      },
});